import { useCallback } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { UpdateNotice } from './UpdateNotice';

/** Registers the service worker (injectRegister is off) and offers each new version. */
export function AppUpdates() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const update = useCallback(() => void updateServiceWorker(true), [updateServiceWorker]);
  return <UpdateNotice needRefresh={needRefresh} update={update} />;
}
